import { I18n } from "@ies/starling_intl";
import { Tabs, Modal, Select, Message } from "@arco-design/web-react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { IconFont } from "@/components/IconFont";
import { baseURL } from "@/common/const";
import { AXIOS_ENV_URL } from "@/utils/env";

/** 工具箱Modal */
export const MyProjectModal: React.FC<{
  visible: boolean;
  setVisible: (v: boolean) => void;
  projects: any[];
  url: string;
  // setSelectProject: (v: number) => void;
}> = props => {
  const { visible, setVisible, projects, url } = props;
  const { Option } = Select;
  const [curPid, setCurPid] = useState(0);
  const history = useHistory();
  return (
    <Modal
      visible={visible}
      title={I18n.t("please_select_an_item", {}, "请选择一个项目")}
      onCancel={() => setVisible(false)}
      onOk={() => {
        if (curPid) {
          setVisible(false);
          history.push(`/${curPid}${url}`);
        } else {
          Message.error(I18n.t("please_select_an_item", {}, "请选择一个项目"));
        }
      }}>
      <Select onChange={val => setCurPid(val)}>
        {projects.map(proj => {
          return (
            <Option key={proj.id} value={proj.id}>
              {proj.name}
            </Option>
          );
        })}
      </Select>
    </Modal>
  );
};

/** 工具箱下拉框 */
export const ToolBoxDropdown: React.FC<{
  userInfo: any;
  id: number;
  curAid: number;
  gmRight: boolean;
  codeAuth: boolean;
  setUrl: (v: string) => void;
  setVisible: (v: boolean) => void;
}> = props => {
  const { userInfo, id, curAid, gmRight, codeAuth, setUrl, setVisible } = props;
  const history = useHistory();
  const [curTab, setCurTab] = useState("1");
  // const { Option } = Select;
  const { TabPane } = Tabs;

  const jumpTo = (url: string) => {
    if (id) {
      history.push(`/${id}${url}`);
    } else {
      setUrl(url);
      setVisible(true);
      // history.push(`/${curPid}${url}`);
    }
  };

  return (
    <Tabs
      className="toolbox-tabs"
      tabPosition="left"
      activeTab={curTab}
      style={{
        backgroundColor: "white",
        boxShadow: "2px 2px 2px rgb(243 243 243)",
        // maxHeight: '241px',
        // height: curTab === '2' ? '241px' : 'auto',
        display: "flex",
      }}>
      <TabPane
        key="1"
        title={
          <span
            className="tab-header"
            onMouseOverCapture={() => {
              setCurTab("1");
            }}>
            <IconFont type="icontool" style={{ marginRight: 6 }} />
            {I18n.t("test_tools", {}, "测试工具")}
          </span>
        }>
        <div
          className="tablink"
          onClick={() => jumpTo("/hold-all/re-sign-package")}>
          <IconFont type="iconpack" />
          <span>
            {I18n.t("testing_suite_re_sign", {}, "测试包重签")}
            <p>
              {I18n.t(
                "ios_package_re_sign___abb_to_apk___apk__obb_merge",
                {},
                "iOS包重签 & abb转apk & apk、obb合并",
              )}
            </p>
          </span>
        </div>
        {codeAuth ? (
          <div className="tablink" onClick={() => jumpTo("/code-coverage")}>
            <IconFont type="icongongshitongji" />
            <span>
              覆盖率采集
              <p>通过插桩进行的游戏覆盖率采集</p>
            </span>
          </div>
        ) : null}
        {([290].includes(id) && baseURL !== AXIOS_ENV_URL.development) ||
        ([220].includes(id) && baseURL === AXIOS_ENV_URL.development) ? (
          <div className="tablink" onClick={() => jumpTo("/interfacetest")}>
            <IconFont type="iconshenhe1" />
            <span>
              {I18n.t("interface_automation", {}, "接口自动化")}
              <p>
                {I18n.t(
                  "interface_automation_test_report",
                  {},
                  "接口自动化测试报告",
                )}
              </p>
            </span>
          </div>
        ) : null}
        {[2682, 362004, 6037].includes(curAid) && gmRight ? (
          <div className="tablink" onClick={() => jumpTo("/gm-config")}>
            <IconFont type="iconpack" />
            <span>
              {I18n.t("gm_directive", {}, "GM指令")}
              <p>
                {I18n.t(
                  "gm_command_and_batch_gm_configuration",
                  {},
                  "GM指令及批量GM配置",
                )}
              </p>
            </span>
          </div>
        ) : null}
      </TabPane>
      {userInfo?.userInfo?.userType !== 0 && !userInfo?.userInfo?.isBpo ? (
        <TabPane
          key="2"
          title={
            <span
              className="tab-header"
              onMouseOverCapture={() => {
                setCurTab("2");
              }}>
              <IconFont type="iconshop" style={{ marginRight: 6 }} />
              {I18n.t("shop_tools", {}, "商店工具")}
            </span>
          }>
          {userInfo?.userInfo?.isInternal &&
          userInfo?.userInfo?.userType !== 0 ? (
            <div className="tablink" onClick={() => jumpTo("/recommend")}>
              <IconFont type="iconrecommend" />
              <span>
                {I18n.t("store_recommendation_application", {}, "商店推荐申请")}
                <p>
                  {I18n.t(
                    "ios_/gp_store_recommendation_application_ability__please_contact_ug_classmate_to",
                    {},
                    "iOS/GP商店推荐申请能力，请联系UG同学沟通细节",
                  )}
                </p>
              </span>
            </div>
          ) : null}
          <div className="tablink" onClick={() => jumpTo("/certManage")}>
            <IconFont type="iconcertificate" />
            <span>
              {I18n.t(
                "apple_store_certificate_management",
                {},
                "Apple商店证书管理",
              )}
              <p>
                {I18n.t(
                  "update_and_download_the_project_apple_store_packaging_certificate_and_descriptio",
                  {},
                  "更新、下载项目Apple商店打包证书及描述文件",
                )}
              </p>
            </span>
          </div>
          <div className="tablink" onClick={() => jumpTo("/review/apple/iap")}>
            <IconFont type="iconconfig" />
            <span>
              {I18n.t("apple_store_iap_view", {}, "Apple商店IAP查看")}
              <p>
                {I18n.t(
                  "real_time_pull_store_internal_purchase_configuration",
                  {},
                  "实时拉取商店内购配置",
                )}
              </p>
            </span>
          </div>
          <div className="tablink" onClick={() => jumpTo("/review/google/iap")}>
            <IconFont type="iconconfig" />
            <span>
              {I18n.t("google_store_iap_view", {}, "Google商店IAP查看")}
              <p>
                {I18n.t(
                  "real_time_pull_store_internal_purchase_configuration",
                  {},
                  "实时拉取商店内购配置",
                )}
              </p>
            </span>
          </div>
        </TabPane>
      ) : null}
      <TabPane
        key="3"
        title={
          <span
            className="tab-header"
            onMouseOverCapture={() => {
              setCurTab("3");
            }}>
            <IconFont type="iconcube" style={{ marginRight: 6 }} />
            {I18n.t("package_inspection_tool", {}, "包检查工具")}
          </span>
        }>
        <div className="tablink" onClick={() => jumpTo("/protection")}>
          <IconFont type="iconlock" />
          <span>
            {I18n.t("game_pack_reinforcement_check", {}, "游戏包加固检查")}
            <p>
              {I18n.t(
                "game_code_hardening_capability_check",
                {},
                "游戏代码加固能力检查",
              )}
            </p>
          </span>
        </div>
        <div
          className="tablink"
          onClick={() => jumpTo("/package-inspection/static-channel")}>
          <IconFont type="icondone" />
          <span>
            {I18n.t("static_channel_check", {}, "静态渠道检查")}
            <p>
              {I18n.t(
                "channel_scan_risk_one_click_check",
                {},
                "渠道扫描风险一键检查",
              )}
            </p>
          </span>
        </div>
        <div
          className="tablink"
          onClick={() => jumpTo("/storeManagement/ios/reveal-scan")}>
          <IconFont type="icondevelop" />
          <span>
            {I18n.t("ios_/gp_committal_hearing_scan", {}, "iOS/GP预审扫描")}
            <p>
              {I18n.t(
                "bag_shop_arraignment_risk_is_discovered_in_advance",
                {},
                "包体商店提审风险提前发现",
              )}
            </p>
          </span>
        </div>
        <div className="tablink" onClick={() => jumpTo("/privacy-scan")}>
          <IconFont type="iconprivate" />
          <span>
            {I18n.t("privacy_compliance_check", {}, "隐私合规检查")}
            <p>
              {I18n.t(
                "privacy_compliance_check_report",
                {},
                "隐私合规检查报告",
              )}
            </p>
          </span>
        </div>
      </TabPane>
    </Tabs>
  );
};
